module.exports = __webpack_public_path__ + "static/HelveticaNeueLTPro-Roman-9fe10c6fbe2ecc99f210671aac25f2ec.woff2";